var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import BatchManageService from '../../../api/BatchManageService';
import GoodService from "../../../api/GoodService";
import VueDialog from "../../../interface/IVueDialog";
import BatchList from './BatchList.vue';
import QueryHeader from './QueryHeader.vue';
import CommonService from "../../../api/CommonService";
import { UrlHelper } from "../../../helper/UrlWrapper";
import { getTheDayZeroTime } from '../../../helper/util';
import { billDefaultDate } from '../../../helper/defaultDate';
var EActiveType;
(function (EActiveType) {
    EActiveType["UNSELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
function getDefaultFormData() {
    var data = {
        depot_ids: [],
        keyword: '',
        goods_type_id: null,
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
    };
    return data;
}
var BatchManage = (function (_super) {
    __extends(BatchManage, _super);
    function BatchManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.total = 0;
        _this.list = [];
        _this.order_ids = [];
        _this.loading = false;
        _this.formData = getDefaultFormData();
        _this.productionDate = null;
        _this.dialogVisible = false;
        _this.filter = {};
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            }
        };
        return _this;
    }
    BatchManage.prototype.created = function () {
        this.goodService = GoodService.getInstance();
        this.batchManageService = BatchManageService.getInstance();
        this.commonService = CommonService.getInstance();
        this.order_ids = [];
        this.getBatchList();
    };
    BatchManage.prototype.goodsTypeSelect = function (node) {
        this.formData.goods_type_ids = node.goods_type_id;
        this.search();
    };
    BatchManage.prototype.reset = function () {
        this.formData = getDefaultFormData();
        this.search();
    };
    BatchManage.prototype.getBatchList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.loading = true;
        this.batchManageService.getList(Object.assign({}, this.filter, pager)).then(function (res) {
            if (res.data.success) {
                _this.list = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            _this.loading = false;
        }, function (err) {
            _this.$message.error(err.message);
            _this.loading = false;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            _this.loading = false;
        });
    };
    BatchManage.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        this.order_ids = [];
        rows.forEach(function (item) {
            _this.order_ids.push(item.order_id);
        });
    };
    BatchManage.prototype.initFilter = function () {
        this.filter = {
            depot_ids: (this.formData.depot_ids || []).join(','),
            keyword: this.formData.keyword,
            goods_type_ids: this.formData.goods_type_id ? this.formData.goods_type_id : '',
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
        };
    };
    BatchManage.prototype.search = function () {
        var timeDiff = getTheDayZeroTime(new Date(this.formData.e_time)) - getTheDayZeroTime(new Date(this.formData.s_time));
        if (timeDiff < 0 || timeDiff > 365 * 1000 * 24 * 60 * 60) {
            this.$message.warning('最大查询范围不可超过一年');
            return;
        }
        this.initFilter();
        this.getBatchList();
    };
    BatchManage.prototype.close = function () {
        this.$closeDialog();
    };
    BatchManage.prototype.getOrderIds = function () {
        return this.order_ids.join(',');
    };
    BatchManage.prototype.updateProductionData = function () {
        if (this.order_ids.length == 0) {
            this.$message.error('请先选择要修改的批次');
            return;
        }
        this.dialogVisible = true;
    };
    BatchManage.prototype.submitData = function () {
        var _this = this;
        if (this.order_ids.length == 0) {
            this.$message.error('请先选择要修改的批次');
            return;
        }
        if (!this.productionDate) {
            this.$message.error('请先选择生产日期');
            return;
        }
        var data = {
            order_ids: this.order_ids.join(','),
            production_date: this.productionDate
        };
        this.batchManageService.updateProductionDate(Object.assign({}, data)).then(function (res) {
            if (res.data.success) {
                _this.order_ids = [];
                _this.getBatchList();
                _this.$message.success('修改成功');
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        this.dialogVisible = false;
    };
    BatchManage.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.getOrderIds();
        var url = "supplierclientapi/goods_batch/export?order_ids=" + orderIds;
        url = UrlHelper.addParam(url, "token", this.user.token);
        var params = this.filter;
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    BatchManage.prototype.pageChange = function (pager) {
        this.getBatchList(pager);
    };
    BatchManage.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    BatchManage = __decorate([
        Component({
            components: {
                'batch-list-table': BatchList,
                'query-header': QueryHeader,
            },
            computed: {}
        })
    ], BatchManage);
    return BatchManage;
}(VueDialog));
export default BatchManage;
